var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 17C26 15.9724 25.38 15.0896 24.4937 14.7053C24.3785 13.0584 22.6995 11.9537 21.1222 12.5452L15.9093 14.5H8.5C7.11929 14.5 6 15.6193 6 17V25C6 26.2095 6.85888 27.2183 8 27.45V29.382C8 30.1253 8.78231 30.6088 9.44721 30.2764L15 27.5H23.5C24.8807 27.5 26 26.3807 26 25V17ZM8 26.4146C7.4174 26.2087 7 25.6531 7 25V17C7 16.1716 7.67157 15.5 8.5 15.5H14.6982L9.2829 17.5799C8.51007 17.8768 8 18.6191 8 19.447V26.4146ZM21.4733 13.4815C22.328 13.161 23.2323 13.6705 23.4506 14.5H18.7573L21.4733 13.4815ZM16.5 15.5V26.5H23.5C24.3284 26.5 25 25.8284 25 25V17C25 16.1716 24.3284 15.5 23.5 15.5H16.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7125 5.82263C17.8891 5.85623 17.9606 5.94051 17.8886 6.03022L16.1596 8.18539C16.0021 8.38174 15.3595 8.44251 15.217 8.27453L14.485 7.41176C14.475 7.41341 13.156 7.63237 11.4362 8.19019C10.2294 8.5816 9.37495 9.17921 9.09413 9.39192C9.06726 9.41227 8.99782 9.41222 9.00005 9.39137C9.03361 9.0782 9.25301 7.90189 10.6753 7.08016C11.6234 6.5324 13.3527 6.09308 13.3638 6.09028L12.7037 5.31226C12.5611 5.14428 13.0837 4.942 13.4702 5.01554L17.7125 5.82263ZM15.1269 11.4425C14.9439 11.4196 14.854 11.3401 14.9055 11.2468L16.1423 9.00407C16.255 8.79974 16.8799 8.70136 17.059 8.85975L17.979 9.67327C17.9885 9.67105 19.2502 9.37554 20.8345 8.71977C21.9462 8.25963 22.6618 7.61555 22.8933 7.38768C22.9154 7.36588 22.9845 7.36182 22.9869 7.38266C23.0235 7.69567 23.0681 8.87689 21.8383 9.77715C21.0186 10.3773 19.3984 10.9159 19.388 10.9193L20.2176 11.6529C20.3967 11.8113 19.9227 12.0432 19.5222 11.993L15.1269 11.4425Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverse);
export default __webpack_public_path__ + "static/media/Reverse.e040925ed0233323626e17afee478909.svg";
export { ForwardRef as ReactComponent };